import {ifElse, ifThen, isString, pipe, toNumber} from '@yandex-delivery/utils'

import type {DraftRepository} from './types'

// тут можно внедрить логгер и прочие зависимости
type DraftRepositoryParams = {
  key: string
}

const STORAGE_PERSIST_TIME = 8 * 60 * 60 * 1000

function createSafeInvoke<Args extends any[], Return>(func: (...args: Args) => Return) {
  return (...args: Args) => {
    try {
      return func(...args)
    } catch {
      //
    }
  }
}

function isExpired(dateSaved: number) {
  return Date.now() - dateSaved >= STORAGE_PERSIST_TIME
}

const removeStorageItem = createSafeInvoke((key: string) => window.localStorage.removeItem(key))

const setStorageItem = createSafeInvoke((key: string, value: string) => window.localStorage.setItem(key, value))

const getStorageItem = createSafeInvoke((key: string) => window.localStorage.getItem(key))

const parseStringToJson = createSafeInvoke((str: string) => JSON.parse(str))

const stringifyJson = createSafeInvoke(obj => JSON.stringify(obj))

export function createDraftRepository<Storage>({key}: DraftRepositoryParams): DraftRepository<Storage> {
  // если захочется другое хранилище, например переехать на бек или indexedDB
  // то в аргументах нужно завести условный fetch (слой инфтраструктуры)
  // и уже разруливать в нем
  const DATE_SAVED_KEY = `${key}_dateSaved`

  function fetchClearDraftSync() {
    removeStorageItem(key)
  }

  function getDraft() {
    return pipe(
      getStorageItem(key),
      ifThen(
        isString, //
        parseStringToJson,
      ),
    )
  }

  return {
    fetchPersistDraftSync(obj: Parameters<DraftRepository<Storage>['fetchPersistDraftSync']>[0]) {
      const str = stringifyJson(obj)

      if (str) {
        setStorageItem(key, str)
        setStorageItem(DATE_SAVED_KEY, String(Date.now()))
      }
    },

    fetchRestoreDraftSync(): ReturnType<DraftRepository<Storage>['fetchRestoreDraftSync']> {
      return pipe(
        getStorageItem(DATE_SAVED_KEY),
        savedDate => toNumber(savedDate, Infinity),
        ifElse(
          isExpired, //
          fetchClearDraftSync,
          getDraft,
        ),
      )
    },

    fetchClearDraftSync,
  }
}
